import { gql } from '@apollo/client';

export const ACTIVITY = gql`
  fragment activity on Activity {
    id
    activityTargets {
      id
      endDate
      groupingType
      numberOfSessions
      expectedNumberOfAttendees
      plannedDuration
      startDate
      cohort {
        id
        name
      }
      frequency {
        id
      }
      frequencyType {
        id
      }
      institution {
        id
        name
      }
    }
    archivedSessionAttendees {
      id
    }
    stakeholderTypes {
      id
      name
    }
    attendeeCount
    audienceSize {
      id
      name
    }
    audienceType {
      id
      name
    }
    groupInstitutions {
      id
      name
    }
    groupCohorts {
      id
      name
    }
    inputTypes {
      id
      name
      quantity {
        quantity
      }
    }
    interfaceType {
      id
      name
    }
    intervention {
      id
      name
      fromDate
      toDate
    }
    interventions {
      id
      name
    }
    multiDay
    name
    numberOfAttendees
    renderGroupForm
    weeklyTracking
    weekStartDay
    numberOfDaysPerWeek
    sunday
    monday
    tuesday
    wednesday
    thursday
    friday
    saturday
    historicalData
    trackingLevel
    sessionBasedAttendees
    sessionAttendees {
      id
    }
    sessions {
      id
    }
    tags {
      name
    }
    targetAudiences {
      id
      name
    }
    targetGroup {
      id
      name
    }
    totalNumberOfSessions
    type {
      id
      name
    }
  }
`;
